import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss']
})
export class ProgressCircleComponent  {
  @Input() value: number;
  @Input() diameter = 20;
  @Input() strokeWidth = 3;

  constructor() { }


}
